export default () => {
    const socialLoginWrap = document.querySelector('.customLoginPage__social-login');
    if (!socialLoginWrap) return;
    const anchors = socialLoginWrap.querySelectorAll('a');
    anchors.forEach(anchor => {
        anchor.style.setProperty('margin-left', '0', 'important');
        anchor.style.setProperty('width', '100%', 'important');
    });
}